/** Tokens de marca Rankmi IA — alineados a Figma Centro de Aprendizaje LMS */
export const AI_GRADIENT =
  'linear-gradient(90deg, #ff66a1 -18.3%, #ff5d2c 100%)'

export const AI_PINK = '#ff66a1'
export const AI_ORANGE = '#ff5d2c'
export const AI_TERTIARY_TEXT = '#213f68'

export const AI_BANNER_BACKGROUND = `linear-gradient(90deg, rgba(255, 102, 161, 0.08) 5.36%, rgba(255, 93, 44, 0.08) 76.34%), #fff`

/** Fondo del modal de generación (Figma Modal IA) */
export const AI_MODAL_BACKGROUND = `linear-gradient(90deg, rgba(255, 102, 161, 0.04) 0%, rgba(255, 93, 44, 0.04) 100%), #ffffff`

export const AI_DARK_GRAY = '#363636'
export const AI_GRAY = '#757575'

/** Línea vertical del stepper (Figma — siempre gris, sin cambio por estado) */
export const AI_STEP_CONNECTOR = '#e8e8e8'

/** Borde suave de círculos en paso pendiente */
export const AI_STEP_BORDER = 'rgba(255, 102, 161, 0.35)'

/** Borde card meta evaluación IA (Figma Card IA — rosa/naranja suave) */
export const AI_META_CARD_BORDER = 'rgba(255, 102, 161, 0.4)'

/** Ancho del modal de generación con IA (Figma Modal IA) */
export const AI_GENERATION_MODAL_WIDTH = 600

/** Ancho del modal de revisión / preview (Figma Modal IA preview) */
export const AI_PREVIEW_MODAL_WIDTH = 800

/** Ancho del modal de error al generar con IA */
export const AI_ERROR_MODAL_WIDTH = 600

export const AI_POSITIVE_GREEN = '#00b47c'
export const AI_POSITIVE_GREEN_BORDER = '#6ecda5'

/** Altura compartida botones toolbar (IA + Mover bloques) según Figma */
export const AI_TOOLBAR_ACTION_HEIGHT = '54px'
